import { Box, Button, Grid2, Tab, Tabs, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, updateProfilePicture, getExperience, getSkills } from "Slices/thunks";
import SettingsBackground from "Assets/Images/SettingsBackground.png";
import ProfileImage from "Assets/Images/ProfileImage.png";
import Loader from "Components/Common/Loader";
import AccountDetails from "Components/Settings/AccountDetails";
import AcademicJobProfile from "Components/Settings/AcademicJobProfile";
import ChangeEmailPhone from "Components/Settings/ChangeEmailPhone";
import ChangePassword from "Components/Settings/ChangePassword";
import Notifications from "Components/Settings/Notifications";
import ImageCrop from "Components/Common/ImageCrop";
import { auth } from "../../firebase";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "& .settingsHeader": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    overflow: "hidden",
    "& .coverImg": {
      maxHeight: "250px",
      minHeight: "250px",
      width: "100%",
    },
    "& .profileImg": {
      borderRadius: "50%",
      maxWidth: "150px",
      maxHeight: "150px",
    },
    "& .profileName": {
      marginTop: "-110px",
      marginLeft: "20px",
    },
  },
});

const Settings = () => {
  const user = auth.currentUser;
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("account_details");
  const [file, setFile] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [isCrop, setIsCrop] = useState(false);
  const [isApiCalling, setIsApiCalling] = useState(false);

  const inputRef = useRef(null);

  const { Profile, isLoading, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    isLoading: state.Profile.loading,
    Translation: state.Translation.translation?.Settings || {},
  }));

  const profileInfo = React.useMemo(() => {
    if (Object.keys(Profile || {}).length) {
      return Profile;
    }
    return {}
  }, [Profile]);

  const handleChangeImage = () => {
    inputRef.current?.click();
  };

  const handleFileUpload = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    
    setFile(URL.createObjectURL(selectedFile));
    const reader = new FileReader();
    reader.onloadend = () => {
      const imageDataUrl = reader.result;
      const base64 = imageDataUrl.split(',')[1];
      setBase64Image(base64);
    };
    reader.readAsDataURL(selectedFile);

    setIsCrop(true);
    e.target.value = null; // Clear the file input
  };

  const onSubmitCroppedImage = async () => {
    try {
      setIsApiCalling(true);
      await dispatch(updateProfilePicture({ImageData: base64Image})).unwrap();
      setIsApiCalling(false);
      setIsCrop(false);
    } catch (error) {
      setIsApiCalling(false);
      console.error('Error uploading image:', error);
    }
  }

  const cancelCropImage = () => {
    isApiCalling && setIsApiCalling(false);
    setIsCrop(false);
    setFile(null);
  }

  useEffect(() => {
		return () => {
      if (file) {
        URL.revokeObjectURL(file);
      }
		};
	}, []);

  useEffect(() => {
    dispatch(getExperience())
    dispatch(getSkills())

  }, [dispatch])

  return (
    isLoading ? <Loader /> :
    <>
      <Grid2 sx={styles}>
        <Typography fontWeight={500} variant="title">
          {Translation?.PersonalInformation}
        </Typography>
        <Box className="settingsHeader">
          <img className="coverImg" src={SettingsBackground} alt="" />
          <Box
            className="profileName"
            display={"flex"}
            alignItems={"center"}
            gap="30px"
          >
            <Box
              sx={{
                position: "relative",
                "& button": {
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, 0%)",
                  whiteSpace: "nowrap",
                  opacity: "0.7",
                },
              }}
            >
              <img className="profileImg" src={profileInfo?.ProfilePictureUrl} alt="" />
              {/* <img className="profileImg" src={ProfileImage} alt="" /> */}
              <input type="file" ref={inputRef} onChange={handleFileUpload} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
              <Button size="small" variant="contained" color="white" onClick={handleChangeImage}>
                {Translation?.ChangeImage}
              </Button>
            </Box>
            <Box>
              <Typography color="white" fontWeight={500} variant="title">
                {profileInfo?.FullName}
              </Typography>
              <Typography color="white">{Translation?.Student}</Typography>
            </Box>
          </Box>
          <Tabs
            sx={{ marginTop: "10px" }}
            type="primary"
            value={selectedTab}
            onChange={(e, val) => setSelectedTab(val)}
          >
            <Tab value={"account_details"} label={Translation?.AcademicDetails} />
            <Tab value={"academic"} label={Translation?.AcademicAndJobProfile} />
            <Tab value={"email_phone"} label={Translation?.UpdateEmailAndContactNumber} />
            {/* <Tab value={"password"} label={Translation?.ChangePassword} /> */}
            <Tab value={"notification"} label={Translation?.Notification} />
          </Tabs>
        </Box>
        {selectedTab == "account_details" ? (
          <AccountDetails profileInfo={profileInfo} />
        ) : selectedTab == "academic" ? (
          <AcademicJobProfile profileInfo={profileInfo} />
        ) : selectedTab == "email_phone" ? (
          <ChangeEmailPhone profileInfo={profileInfo} />
        ) : selectedTab == "password" ? (
          <ChangePassword />
        ) : selectedTab == "notification" ? (
          <Notifications profileInfo={profileInfo} />
        ) : (
          ""
        )}
      </Grid2>

      <ImageCrop isOpen={isCrop} imageToCrop={file} isApiCalling={isApiCalling} setBase64Image={setBase64Image}
        setCroppedImage={setFile} cancelCropImage={cancelCropImage} onSubmitCroppedImage={onSubmitCroppedImage} />
    </>
  );
};

export default Settings;
